import { getParticipantDisplayText } from './participantUtils';
import type { CompetitionParticipant } from '../../types/competition';

interface ParticipantLabelProps {
  participant: CompetitionParticipant;
  className?: string;
}

export function ParticipantLabel({ participant, className }: ParticipantLabelProps) {
  return <span className={className}>{getParticipantDisplayText(participant)}</span>;
}
